import { useState } from "react";
import { connect } from "react-redux";
import styles from "./HomeProducts.module.css";
import * as actions from "../../../store/actions/index";
import Spinner from "../../Spinner/Spinner";
import FlexContainer from "../../UI/FlexContainer/FlexContainer";
import ProductCard from "../../ProductCard/ProductCard";
import { withRouter } from "react-router-dom";
import Modal from "../../UI/Modal/Modal";
const SearchProductsAdmin = (props) => {
  const [delteModal, setDeleteModal] = useState(false);
  const [selectedProductId, setProductId] = useState(null);
  let isLoaded = props.searchProductData !== null;

  // useEffect(() => {
  //     if (!isLoaded) {
  //         console.log("home products request sent to server")
  //         props.fetchHomeProducts();
  //     }
  // }, [])

  const handleProductDelete = () => {
    if (selectedProductId) {
      props
        .deleteProduct(selectedProductId)
        .then((r) => {
          setDeleteModal(false);
        })
        .catch((error) => {
          setDeleteModal(false);
        });
    }
  };
  if (props.loading) {
    return (
      <div className={styles.Spinner}>
        <Spinner />
      </div>
    );
  }

  if (!isLoaded) {
    return null;
  }

  return (
    <div className="container container-md" style={{ padding: "20px" }}>
      <FlexContainer>
        {props.searchProductData.map((product) => (
          <span
            className="border-secondary p-2 rounded-sm mr-4"
            style={{ border: "1px solid", width: "240px" }}
          >
            <span className="d-flex w-100 justify-content-between">
              {props.editProductBtn && (
                <a href={`/admin/editProduct/${product.id}`} target="_blank">
                  <button
                    className="btn btn-sm btn-primary"
                    //   onClick={() =>
                    //     props.history.push(`/admin/editProduct/${product.id}`)
                    //   }
                  >
                    Edit
                  </button>
                </a>
              )}

              {props.deleteProductBtn && (
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    setProductId(product.id);
                    setDeleteModal(true);
                  }}
                >
                  {" "}
                  Delete
                </button>
              )}
              {props.productCardBtnData &&
                props.productCardBtnData.map((btn) => (
                  <button
                    className={btn.className}
                    onClick={() => btn.clicked(product.id)}
                    disabled={btn.isBtnDisabled(product.id)}
                  >
                    {btn.name}
                  </button>
                ))}
            </span>
            <ProductCard product={product} />
          </span>
        ))}
      </FlexContainer>

      {delteModal && (
        <Modal
          show={delteModal}
          modalClosed={() => {
            setDeleteModal(false);
            setProductId(null);
          }}
          modalStyle={{
            width: "40%",
            left: "4%",
            overflowY: "scroll",
            maxHeight: "70%",
            // top:"15%"
          }}
        >
          <h4>Are you sure you want to delete the product?</h4>
          <hr />
          <div className="text-center">
            <button
              className="btn  btn-danger m-2"
              onClick={handleProductDelete}
              disabled={props.deleteProductLoading}
            >
              {props.deleteProductLoading ? "Deleting" : "Yes"}
            </button>
            <button
              className="btn  btn-success m-2"
              onClick={() => {
                setDeleteModal(false);
                setProductId(null);
              }}
              disabled={props.deleteProductLoading}
            >
              No
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    productData: state.homeProducts.productData,
    searchProductData: state.homeProducts.searchProductData,
    loading: state.homeProducts.loading,
    deleteProductLoading: state.homeProducts.deleteProductLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchHomeProducts: () => dispatch(actions.fetchHomeProducts()),
    deleteProduct: (id) => dispatch(actions.deleteProduct(id)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SearchProductsAdmin));
